export default function () {
  const $root = $('.header-l');
  const $menu = $root.find('.menu-l');
  const body = $('body');

  $('.btn-menu').on('click', function () {
    $menu.addClass('menu-l--open');
    body.addClass('no-scroll');
  });
  $('.close').on('click', function () {
    $menu.removeClass('menu-l--open');
    body.removeClass('no-scroll');
  });


}



// WEBPACK FOOTER //
// ./resources/assets/js/new-landing-constructor/header/index.js